// Import the necessary function from the Redux Toolkit library
import {  createSlice } from "@reduxjs/toolkit";

const initialState = {
  isCartDrawer: false,
  cartDetails: [],
  cartTotalAmount:{},
};

export const cartSlice = createSlice({
  name: "cartSlice",
  initialState,
  reducers: {
    setIsCartDrawer: (state: any, action: any) => {
      state.isCartDrawer = action.payload;
    },
    setCartDetails: (state: any, action: any) => {
      state.cartDetails = action.payload;
    },
    setCartTotalAmount: (state: any, action: any) => {
      state.cartTotalAmount = action.payload;
    },
 
  },

});

// Export the action creator generated by createSlice
export const { setIsCartDrawer,setCartDetails ,setCartTotalAmount}: any = cartSlice.actions;

// Export the reducer function generated by createSlice
export default cartSlice.reducer;
